import axios from 'axios';

const API_KEY = '0baccfad9c324360bfb122bc5f753088';

const rawgApiClient = axios.create({
    baseURL: 'https://api.rawg.io/api',
    params: {
        key: API_KEY,
    },
});

export interface RawgGame {
    id: number;
    name: string;
    background_image: string;
    description?: string;
    released?: string;
    rating?: number;
    metacritic?: number;
    short_screenshots?: { id: number; image: string }[];
    genres?: { id: number; name: string; slug: string }[];
    platforms?: { platform: { id: number; name: string; slug: string } }[];
}

interface GameStoreResponse {
    results: {
        id: number;
        game_id: number;
        url: string;
        store_id: number;
    }[];
}

const STORE_NAMES: Record<number, string> = {
    1: 'Steam', 2: 'Xbox Store', 3: 'PlayStation Store', 4: 'App Store', 5: 'GOG',
    6: 'Nintendo Store', 7: 'Xbox 360 Store', 8: 'Google Play', 9: 'itch.io', 11: 'Epic Games',
};

export const searchGames = async (query: string): Promise<RawgGame[]> => {
    if (!query) return [];
    try {
        const response = await rawgApiClient.get('/games', {
            params: {
                search: query,
                page_size: 5,
                fields: 'id,name,background_image,released,rating,metacritic,description',
            },
        });
        return response.data.results;
    } catch (error) {
        console.error("Error searching games on RAWG:", error);
        return [];
    }
};

export const getGameDetails = async (gameId: number): Promise<RawgGame | null> => {
    try {
        console.log(`Запрос детальной информации о игре ${gameId}`);
        const response = await rawgApiClient.get<RawgGame>(`/games/${gameId}`);
        console.log(`Получены данные игры ${gameId}:`, {
            name: response.data.name,
            hasDescription: !!response.data.description,
            descriptionLength: response.data.description?.length || 0
        });
        return response.data;
    } catch (error) {
        console.error(`Ошибка при получении информации о игре ${gameId}:`, error);
        return null;
    }
};

export const getGameStoreUrl = async (gameId: number): Promise<string | null> => {
    try {
        const response = await rawgApiClient.get<GameStoreResponse>(`/games/${gameId}/stores`);
        const stores = response.data.results;
        if (!stores || stores.length === 0) return null;

        const steamStore = stores.find(s => s.store_id === 1);
        if (steamStore) return steamStore.url;

        const epicStore = stores.find(s => s.store_id === 11);
        if (epicStore) return epicStore.url;

        const gogStore = stores.find(s => s.store_id === 5);
        if (gogStore) return gogStore.url;

        return stores[0].url;
    } catch (error) {
        console.error(`Error fetching stores for game ${gameId}:`, error);
        return null;
    }
};

export interface GameStoreInfo {
    store: { id: number; name: string };
    url: string;
}

export const getGameStores = async (gameId: number): Promise<GameStoreInfo[]> => {
    try {
        const response = await rawgApiClient.get<GameStoreResponse>(`/games/${gameId}/stores`);
        const stores = response.data.results;
        if (!stores || stores.length === 0) return [];

        return stores.map(s => ({
            store: { id: s.store_id, name: STORE_NAMES[s.store_id] || 'Магазин' },
            url: s.url,
        }));
    } catch (error) {
        console.error(`Error fetching stores for game ${gameId}:`, error);
        return [];
    }
};
